export enum PromotionTypeEnum {
    PERCENTAGE = "percentage",
    FIXED = "fixed",
};
